import { Component, OnInit, Input } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { InProductsService } from "../../services/inventory/in-products.service";
import { environment } from "../../../../environments/environment";
import { VchrprintComponent } from "../../../shared/component/vchrprint/vchrprint.component";
import { ImageSelectComponent } from "../../../shared/component/imageselect/imageselect.component";
import { InToolsService } from "../../services/inventory/in-tools.service";

export interface Items {
  title: string;
  Items: any;
  PromoId: string;
}

@Component({
  selector: 'app-promotionitemimage',
  templateUrl: './promotionitemimage.component.html',
  styleUrls: ['./promotionitemimage.component.css']
})
export class PromotionItemImageComponent extends DialogComponent<Items, boolean>
  implements Items, OnInit {

  title: string = "";
  Items: any;
  PromoId: string = ""

  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;
  loading: boolean = false;
  ItemList: PromotionImageItem[] = [];
  // selectAllImageBarcode:boolean=false;
  SelectedImageList: PromotionImageItem[] = [];
  DefaultImage: string = "";
  ItemUpdateList: PromotionImageItem[] = [];
  selectedIndex: number = -1;
  selectedRow = new PromotionImageItem();
  ReportList: any = [];
  SelectedReport: string = "";

  constructor(dialogService: DialogService, private ds: DataService, private ips: InProductsService, private it: InToolsService) {
    super(dialogService);
  }

  ngOnInit() {
    this.ItemList = this.Items;
    this.get_DefaultImage();
    this.get_ReportMenu();
    this.getProductImages();
  }

  getProductImages() {
    this.loading = true;
    this.ips.Get_ItemImageByBarcode(this.ItemList).subscribe(res => {
      if (res.Success) {
        for (let i of res.data) {
          if (i.ItemImagePath == "") {
            i.ItemImagePath = this.DefaultImage;
          }
        }
        this.ItemList = res.data;
        this.loading = false;
      }
      else {
        this.ItemList = [];
        this.loading = false;
      }
    })
  }

  selectAllImage(e) {
    for (let i of this.ItemList) {
      i.Selected = true;
    }
  }

  unCheckAll(e) {
    for (let i of this.ItemList) {
      i.Selected = false;
    }
  }

  selectImageChange(e) {
    // for (let i of this.ItemList) {
    //   if (i.Selected == false) {
    //     this.selectAllImageBarcode = false;
    //     break;
    //   } else {
    //     this.selectAllImageBarcode = true;
    //   }
    // }
  }

  getnewItemImages() {
    this.SelectedImageList = [];
    for (let i of this.ItemList) {
      if (i.Selected) {
        this.SelectedImageList.push(i);
      }
    }
    if (this.SelectedImageList.length == 0) {
      alert("Please select record(s)");
    }
    else {

      var data = {
        ItemList: this.SelectedImageList,
        GoogleApiKey: this.ds.Settings.GoogleApiKey,
        SearchEngineKey: this.ds.Settings.GoogleSearchEngineKey,
        ImageWidth: this.ds.Settings.Width,
        DefaultImage: this.DefaultImage,
        ImageHeight: this.ds.Settings.Height
      }
      this.loading = true;
      this.ips.Get_ImageOnFetchForPromotion(data).subscribe(res => {
        if (res.Success) {
          for (let img of res.data.ItemList) {
            if (img.ItemImagePath != "") {
              this.ItemList.find(x => x.Barcode == img.Barcode).ItemImagePath = img.ItemImagePath;
            }
          }
          this.loading = false;
        }
        else {
          alert(res.error.UsrMsg);
          //this.ItemList=[];
          this.loading = false;
        }
      })
    }
  }

  get_DefaultImage() {
    var data = {
      SearchText: environment.baseUrl + "/images/noimage.png"
    }
    this.loading = true;
    this.ips.Get_ImageAsBase64(data).subscribe(res => {
      if (res.Success) {
        this.DefaultImage = res.data;
        this.loading = false;
      }
      else {
        this.DefaultImage = "";
        this.loading = false;
      }
    })
  }

  // updateImage(){
  //   this.ItemUpdateList=[];
  //   for (let i of this.ItemList) {
  //     if(i.Selected){   
  //      this.ItemUpdateList.push(i);
  //     }
  //   }
  //   if(this.ItemUpdateList.length==0){
  //    alert("Please select record(s)");
  //   }
  //   else{
  //     this.loading=true;
  //     var data={
  //       PromotionImageItem:this.ItemUpdateList,
  //       ImageWidth:this.ds.Settings.Width,
  //       ImageHeight:this.ds.Settings.Height
  //     }
  //     this.ips.Save_ImageFromPromotion(data).subscribe(res => {
  //       if (res.Success) {    
  //         alert("Image(s) Updated Successfully"); 
  //         this.loading=false;
  //       }
  //       else {
  //         alert(res.error.UsrMsg);
  //         this.loading=false;
  //       }
  //     })
  //   } 
  // }

  SelecteIndex(item, ix) {
    this.selectedIndex = ix;
    this.selectedRow = item;
  }

  get_ImageOnFetchOne() {
    if (this.selectedRow.Barcode != undefined && this.selectedRow.Barcode != "") {
      // var data = {
      //   SearchText: this.selectedRow.Barcode,
      //   GoogleApiKey:this.ds.Settings.GoogleApiKey,
      //   SearchEngineKey:this.ds.Settings.GoogleSearchEngineKey
      // }
      // this.loading = true;
      // this.ips.Get_ImageOnFetchOne(data).subscribe(res => {
      //   if (res.Success) {
      //     this.ItemList.find(x=>x.Barcode==this.selectedRow.Barcode).ItemImagePath = res.data;
      //     this.loading = false;
      //   }
      //   else {
      //     //this.ItemList.find(x=>x.Barcode==this.selectedRow.Barcode).ItemImagePath = this.DefaultImage;
      //     this.loading = false;
      //   }
      // }) 

      let d = this.dialogService
        .addDialog(ImageSelectComponent, { title: "Image List", text: this.selectedRow.Barcode })
        .subscribe(res1 => {
          if (res1.result) {
            this.loading = true;
            var data = {
              Barcode: this.selectedRow.Barcode,
              ItemImagePath: res1.item,
              ImageWidth: this.ds.Settings.Width,
              ImageHeight: this.ds.Settings.Height
            }
            this.ips.Save_SingleImageFromPromotion(data).subscribe(res => {
              if (res.Success) {
                this.ItemList.find(x => x.Barcode == this.selectedRow.Barcode).ItemImagePath = res1.item;
                this.loading = false;
              }
              else {
                alert(res.error.UsrMsg);
                this.ItemList.find(x => x.Barcode == this.selectedRow.Barcode).ItemImagePath = this.DefaultImage;
                this.loading = false;
              }
            })
          }
        });
    }
    else {
      alert("Please select a record");
    }
  }

  generateReport() {
    if (this.PromoId != "") {
      if (this.SelectedReport == "") {
        alert("Please select a Report Flavours");
      }
      else {
        var t = "Promotion";
        var url = environment.reportUrl;
        //var path = "Inventory/rpt";
        // var rptList = []
        // var list = { PromoId: this.PromoId, locationid: this.ds.Settings.LocationId, companyid: this.ds.Settings.CompanyId, branchid: this.ds.Settings.BranchId }
        // var abc: any = JSON.parse(localStorage.getItem("ReportSettings_" + environment.AppName))
        // console.log(abc)
    
        // var sett: boolean = environment.ReportBasedOnPrivilege;
        // for (let i of environment.ReportList) {
        //   if (sett && i.Enable) {
        //     i.Enable = false;
        //     for (let ip of abc) {
        //       if (ip == i.Path) {
        //         i.Enable = true;
        //         continue;
        //       }
        //     }
        //   }
        //   if (i.Module == "Promotion Flavours" && i.Enable) {
        //     for (let it in i.parameters) {
    
        //       i.parameters[it] = this.ds.RptReplacer(i.parameters[it], list)
        //     }
        //     rptList.push(i)
        //   }
        // }
        // console.log(rptList)
        
        var path = this.SelectedReport;
        var parm = { PromoId: this.PromoId, locationid: this.ds.Settings.LocationId, companyid: this.ds.Settings.CompanyId, branchid: this.ds.Settings.BranchId };
        let d = this.dialogService
          .addDialog(VchrprintComponent, {
            title: t,
            reportServerUrl: url,
            reportPath: path,
            parametersList: parm
          })
          .subscribe(res => {
            if (res.result) {
            }
          });
      }

    }
  }

  get_ReportMenu() {
   
    this.loading = true;
    this.it.Get_ReportMenuForPromotionImage().subscribe(res => {
      if (res.Success) {
        this.ReportList = res.data;
        this.SelectedReport = this.ReportList[0].Value;
        this.loading = false;
      }
      else {
        this.ReportList = [];
        this.loading = false;
      }
    })
  }

}
class PromotionImageItem {
  Selected: boolean = false
  Barcode: string = ""
  ItemName: string = ""
  OrgSellingPrice: number = 0
  NewSellingPrice: number = 0
  ItemImagePath: string = ""
  ItemImageBinary: object
  PromotionId: number = 0
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/promotionitemimage/promotionitemimage.component.ts